module.exports = __webpack_public_path__ + "img/logo.5e267b26.png";